import ApplicationState from "./AppState";

class Logger {

    static verbose (message: any) {
        if (ApplicationState.instance.mode === "development" || ApplicationState.instance.mode === "staging")
        this.out("debug", `[${new Date().toISOString()}] Verbose: ${message}`);
    }

    static info (message: any) {
        if (ApplicationState.instance.mode === "development" || ApplicationState.instance.mode === "staging")
        this.out("info", `[${new Date().toISOString()}] Information: ${message}`);
    }

    static warning (message: any) {
        if (ApplicationState.instance.mode === "development" || ApplicationState.instance.mode === "staging")
        this.out("warn", `[${new Date().toISOString()}] Warning: ${message}`);
    }

    static error (message: any) {
        if (typeof message === "string")
            this.out("error", `[${new Date().toISOString()}] Error: ${message}`);
        else {
            this.out("error", `[${new Date().toISOString()}] Error:`);
            this.out("error", message);
        }
    }

    private static out (type: string, message: any, format?: string) {
        if (ApplicationState.instance.mode === "development" || ApplicationState.instance.mode === "staging")
            console[type](format ? `\n%c${message}` : message, format || "");
        else
            setTimeout(console[type].bind(console, format ? `\n%c${message}` : message, format || ""));
    }
}

export default Logger;